import { Download } from '../../icons';
import { brandColor } from '../../styles/brand-colors';
import { useTheme } from '../../theme';
import { SurfaceEmptyState } from '../SurfaceEmptyState';
import type { QuizUpdateRequiredProps } from './QuizUpdateRequired.types';

/**
 * Shown in place of a quiz question this build cannot render — a question type
 * that shipped after the installed client. It carries no answer controls on
 * purpose: a guessed answer written back from a stale binary would overwrite
 * the other platform's copy of the attempt.
 *
 * Labels arrive pre-translated (the DS carries no i18n).
 */
export function QuizUpdateRequired({
  title,
  description,
  testID,
}: QuizUpdateRequiredProps) {
  const { isDark } = useTheme();
  return (
    <SurfaceEmptyState
      artwork={<Download size={40} color={brandColor('secondary', '600', isDark)} />}
      title={title}
      description={description}
      testID={testID}
    />
  );
}
(QuizUpdateRequired as { displayName?: string }).displayName = 'QuizUpdateRequired';
